import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import ReactMarkdown from 'react-markdown'

import { Post as IPost } from '../../../types/post'
import Author from '../Author'

const useStyles = makeStyles((theme) => ({
  background: {
    backgroundImage: "url('/svg/post-background.svg')",
    backgroundRepeat: 'no-repeat',
    position: 'absolute',
    width: '100%',
    height: '825px',
    top: '0',
    left: 0,
    zIndex: -1,
    maskImage: 'linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,0))',
  },
  container: {
    display: 'flex',
    zIndex: 100,
    flexDirection: 'column',
    maxWidth: '678px',
    margin: 'auto',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      padding: '20px',
    },
  },
  title: {
    marginTop: '70px',
    fontFamily: 'Space Grotesk',
    fontWeight: 'bold',
    fontSize: '62px',
    letterSpacing: 0,
    [theme.breakpoints.down('md')]: {
      marginTop: '20px',
      textAlign: 'left',
    },
  },
  podcastImage: {
    top: 0,
    width: 'auto',
    maxWidth: '100%',
    objectFit: 'cover',
    alignSelf: 'flex-start',
    margin: '20px auto',
    borderRadius: '12px',
    [theme.breakpoints.down('md')]: {
      margin: '20px auto',
      alignSelf: 'unset',
      height: 'auto',
    },
  },
  markdown: {
    fontFamily: 'Inter',
    margin: '20px 0',
    fontSize: '18px',
    color: '#2B1841',
    lineHeight: '32px',
    overflowWrap: 'break-word',
    '& img': {
      maxWidth: '100%',
    },
    '& a': {
      color: '#895DD1',
      fontWeight: 'bold',
    },
  },

  iframe: {
    '& iframe': {
      width: '100%',
      height: 'auto',
    },
  },
  sharingContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    '& h5': {
      color: '#895DD1',
      marginRight: '20px',
    },
  },
}))

interface Props {
  post: IPost
  currentUrl: string
}

function Post({ post, currentUrl }: Props): JSX.Element {
  const classes = useStyles({})

  return (
    <>
      <div className={classes.background} />
      <div className={classes.container}>
        <Typography variant="h3" className={classes.title}>
          {post.title}
        </Typography>
        <Author post={post} currentUrl={currentUrl} />
        <img
          width={680}
          height={400}
          src={post.type === 'podcast' ? `/podcast-banner.png` : post.banner?.url}
          className={classes.podcastImage}
          alt={`cryptotesters podcast image`}
        />
        <div className={classes.iframe} dangerouslySetInnerHTML={{ __html: post.iframe }} />
        <ReactMarkdown className={classes.markdown}>{post.text}</ReactMarkdown>
        <Author post={post} currentUrl={currentUrl} />
      </div>
    </>
  )
}

export default Post
